<!--suppress ALL -->
<template>
	<div v-if="alerts.length && activeAlerts.length">
		<transition-group tag="div" name="slide" mode="out-in">
			<div v-for="(alert, index) in alerts" :key="'alert-'+alert.id" v-if="alert.is_active" transition-show="fade" class="q-mb-sm animate fadeUp">
				<q-banner inline-actions rounded :class="['bg-'+alert.variant, 'text-white']">
					<div v-html="alert.description"></div>
					<template v-slot:action>
						<q-btn flat round icon="fa fa-times" size="xs" @click="set_alert_seen(alert)"/>
					</template>
				</q-banner>
			</div>
		</transition-group>
	</div>
</template>

<script>
  import Alert from '../models/Alert.js'
  import {mapActions, mapGetters} from 'vuex'

  export default {
    name: "Alert",
    props: {
      displayPage: {
          type: String,
          default: 'login' // Other option: landing
      }
    },
    computed: {
        ...mapGetters(['login_alerts', 'landing_alerts']),
        activeAlerts() {
            switch (this.displayPage){
                case 'login':
                    return this.login_alerts.filter(alert => alert.is_active)
                case 'landing':
                    return this.landing_alerts.filter(alert => alert.is_active)
            }
        }
    },
	data() {
      return {
        alerts: []
	  }
	},
    methods: {
        ...mapActions(['set_landing_alerts', 'set_login_alerts', 'set_alert_seen'])
    },
	mounted() {
        if (this.displayPage === 'login') {
            this.alerts = this.login_alerts
            this.set_login_alerts()
        } else {
            this.alerts = this.landing_alerts
            this.set_landing_alerts()
        }
	},
    watch: {
        landing_alerts(val) {
            this.alerts = val
        },

        login_alerts(val) {
            this.alerts = val
        }
    }
  }
</script>

<style scoped>
</style>
